export const ITEMS_HAS_ERRORED =  'ITEMS_HAS_ERRORED';
export const ITEMS_IS_LOADING =  'ITEMS_IS_LOADING';
export const ITEMS_FETCH_DATA_SUCCESS =  'ITEMS_FETCH_DATA_SUCCESS';
export const ITEM_SELECTED =  'ITEM_SELECTED';


// WEBPACK FOOTER //
// ./src/js/constants/action-types.js